<a *ngIf="isVisible && billingEnabled" href="{{defaultOfferLink}}" target="_blank" (click)="bannerClick()">
  <div class="banner-container">
    <tyt-plus-tag></tyt-plus-tag>
    <div class="message">
      Enjoying this free video?

      <span class="desktop">
        This video and thousands more are available for
        free thanks to the support of our members.
      </span>

      <span class="mobile">
        Our members make it possible.
      </span>

      <span [innerHtml]="messageContent | trustHtml"></span>
    </div>
  </div>
</a>

<a *ngIf="isVisible" class="dismiss" (click)="dismiss($event)">
  <mat-icon>close</mat-icon>
</a>